import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { updatePassword } from "../../../../redux/reducers/authSlice";
import Spinner from "../../../../components/Spinner";

export default function ChangePw() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  const validationSchema = Yup.object({
    oldPassword: Yup.string().required("Old password is required"),
    newPassword: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("New password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      dispatch(updatePassword(values)).then((res) => {
        if (!res.error) {
          resetForm();
        }
      });
    },
  });

  return (
    <Spinner active={loading}>
      <div className="display-card">
        <h3>Change Password</h3>
        <p>Ensure your account is using a long, random password to stay secure.</p>
        <form onSubmit={formik.handleSubmit}>
          <div className="form-group row">
            <div className="col-xxl-12 col-lg-12 col-md-12 col-12 mb-3">
              <label>
                Old Password <span className="required">*</span>
              </label>
              <input
                type="password"
                name="oldPassword"
                value={formik.values.oldPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.oldPassword && formik.errors.oldPassword ? "is-invalid" : ""}`}
                placeholder="Enter Old Password"
              />
              {formik.touched.oldPassword && formik.errors.oldPassword && (
                <div className="invalid-feedback">{formik.errors.oldPassword}</div>
              )}
            </div>
            <div className="col-xxl-12 col-lg-12 col-md-12 col-12 mb-3">
              <label>
                New Password <span className="required">*</span>
              </label>
              <input
                type="password"
                name="newPassword"
                value={formik.values.newPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.newPassword && formik.errors.newPassword ? "is-invalid" : ""}`}
                placeholder="Enter New Password"
              />
              {formik.touched.newPassword && formik.errors.newPassword && (
                <div className="invalid-feedback">{formik.errors.newPassword}</div>
              )}
            </div>
            <div className="col-xxl-12 col-lg-12 col-md-12 col-12 mb-3">
              <label>
                Confirm New Password <span className="required">*</span>
              </label>
              <input
                type="password"
                name="confirmPassword"
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.confirmPassword && formik.errors.confirmPassword ? "is-invalid" : ""}`}
                placeholder="Confirm New Password"
              />
              {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                <div className="invalid-feedback">{formik.errors.confirmPassword}</div>
              )}
            </div>
            <div className="mt-3 text-center">
              <button
                className="btn btn-primary"
                type="submit"
                style={{ width: '200px' }}
                disabled={loading || !formik.dirty}
              >
                {loading ? "Updating..." : "Change Password"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </Spinner>
  );
}
